import config from 'config';
import {setAuthToken} from 'services/auth';
import {callAPI} from 'services/api';

let _authAPI:any = null;
const _loginCallbacks:(()=>void)[] = [];

export async function initButton(element: HTMLElement, onLogin:()=>void, width?: number) {
  const auth = await initAuth();
  _loginCallbacks.push(onLogin);
  auth.renderButton(element, { theme: 'outline', size: 'large', width: width});
}

export function deinitButton(onLogin:()=>void) {
  const index = _loginCallbacks.indexOf(onLogin);
  if(index >= 0) {
    _loginCallbacks.splice(index, 1);
  }
}

async function initAuth():Promise<any> {
  if(_authAPI) {
    return Promise.resolve(_authAPI);
  }
  const googleAPI = await initAPI();
  _authAPI = googleAPI.accounts.id;
  _authAPI.initialize({
    client_id: config.google.signInClientID,
    callback: onCredentials
  });
  console.log("Google Identity SDK initialized");
  return _authAPI;
}

async function initAPI():Promise<any> {
  const googleAPI:any = (window as any)['google'];
  if(googleAPI) {
    return Promise.resolve(googleAPI);
  }
  return new Promise<any>(
    (resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        console.log("Google Identity SDK loaded");
        const googleAPI:any = (window as any)['google'];
        resolve(googleAPI);
      };
      script.onerror = (err) => {
        console.warn("Error loading Google Identity SDK", err);
        reject(err);
      };
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
    }
  );
}

async function loginWithIDToken(idToken: string): Promise<void> {
  const response = await callAPI('/auth/google/authenticate/', 'POST', { id_token: idToken });
  setAuthToken(response.token);
}

function onCredentials(credentialsResponse: any) {
  loginWithIDToken(credentialsResponse.credential).then(
    () => {
      for(const cb of _loginCallbacks) {
        cb();
      }
    }
  );
}